import commonEs from './es/common.js';
import commonEn from './en/common.js';
import layoutEs from './es/layout.js';
import layoutEn from './en/layout.js';

export const resources = {
  es: { common: commonEs, layout: layoutEs },
  en: { common: commonEn, layout: layoutEn },
} as const;

export const defaultNS = 'common';
